import CloseIcon from '@mui/icons-material/Close'
import { Fab, Tooltip } from '@mui/material'
import CopilotIcon from '@/features/copilot/CopilotIcon'

interface CopilotFabProps {
  open: boolean
  onToggle: () => void
}

const CopilotFab = ({ open, onToggle }: CopilotFabProps) => {
  return (
    <Tooltip title={open ? 'Close copilot' : 'Open copilot'} placement="left">
      <Fab
        size="medium"
        onClick={onToggle}
        aria-label="Toggle CisgenX Copilot"
        sx={{
          color: '#fff',
          backgroundColor: '#004744',
          '&:hover': { backgroundColor: '#003330' },
        }}
      >
        {open ? <CloseIcon /> : <CopilotIcon />}
      </Fab>
    </Tooltip>
  )
}

export default CopilotFab
